<template>
  <div class="swiper-container" >
    <div class="swiper-wrapper">
      <div class="swiper-slide" v-for="(pic, index) in pics" :key="index">
        <img :src="pic + `?imageView2/1/w/750/h/500`" />
      </div>
    </div>
  </div>
</template>
<script>
var config = {};
export default {
    props: {
      pics: {
            type: Array,
            default: () => [],
        },
    },
    methods: {
        initSwiper() {
            var swiper = new Swiper(".swiper-container", {
                autoplay: true,
                paginationClickable: true,
                autoplayDisableOnInteraction: true, // 处理手动滑动后，继续自动滑动
                loop: true,
                observer: true,
                observeParents: true
            });
        },
    },
    mounted(){
        this.initSwiper()
    },
}
</script>
<style lang="less" scoped>
.swiper-container{
  height: 230px;
  .swiper-slide{
    width: 100%;
    height: 100%;
    img{
      width: 100%;
      height: 100%;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/swiperBox.vue